import { showPopAlert } from '../../iba-components/PopAlert'
import Papa from 'papaparse'
import moment from 'moment'
import html2canvas from 'html2canvas'
import { i18next } from '../locales'

import { RANDOM_COLOR } from '../constants'

export function jsonMap(data, template) {
    const result = []
    for (const dt of data) {
        const item = {}
        for (const tp of template) {
            if ((tp.type === 'integer' || tp.type === 'float') && dt[tp.field] === null) {
                dt[tp.field] = 0
            }
            if (dt[tp.field] === 'None') {
                if (tp.type === 'integer' || tp.type === 'float') {
                    dt[tp.field] = 0
                }
                if (tp.type === 'string') dt[tp.field] = ''
            }
            if (tp.type === 'function') {
                const func = tp.func
                item[tp.title] = func(dt[tp.field])
            } else {
                item[tp.title] =
                    dt[tp.field] && tp.type === 'float' && tp.decimal
                        ? Number(dt[tp.field]).toFixed(parseInt(tp.decimal))
                        : dt[tp.field]
            }
        }
        result.push(item)
    }
    return result
}

export function jsonToCSV(data, filename) {
    const date_new = moment().format('YYYY-MM-DD-HHmm')
    const csv = Papa.unparse(data)
    const file = new Blob(['\uFEFF' + csv])
    const urlObject = window.URL || window.webkitURL || window
    const url = urlObject.createObjectURL(file)
    const link = document.createElement('a')
    link.href = url
    link.download = `IBA_${date_new}-${filename}.csv`
    link.click()
    urlObject.revokeObjectURL(url)
}

// format number with commas
export function numberWithCommas(x) {
    return `${x}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function createFormatterString(number) {
    return (string) => (string && string.length > number ? string.slice(0, number) + '...' : string)
}

export function getCommonLabelStyle(formatter) {
    return {
        textStyle: {
            color: '#2d2d2d',
            fontSize: 12
        },
        padding: 4,
        width: 260,
        backgroundColor: '#fff',
        borderColor: '#aaa',
        borderWidth: 1,
        borderRadius: 4,
        position: 'top',
        formatter,
        rich: {
            name: {
                fontWeight: 900,
                fontSize: 14,
                color: '#2d2d2d',
                lineHeight: 20
            },
            key: {
                height: 20,
                color: '#2d2d2d',
                fontSize: 12
            },
            value: {
                padding: [0, 0, 0, 4],
                height: 20,
                color: '#2d2d2d',
                fontSize: 12,
                fontWeight: 900
            }
        }
    }
}

export function initColors() {
    let i = 0
    const colors = JSON.parse(JSON.stringify(RANDOM_COLOR))
    const refreshColor = () => (i = 0)
    return {
        getNextColor() {
            const color = colors[i]
            if (i !== colors.length - 1) {
                i++
            }
            return color
        },
        refreshColor
    }
}

export function deepClone(target, map = new WeakMap()) {
    let cloneTarget
    if (target !== null && (typeof target === 'object' || Array.isArray(target))) {
        cloneTarget = Array.isArray(target) ? [] : {}
        const keys = Object.keys(target)
        if (map.has(target)) {
            return map.get(target)
        }
        for (const key of keys) {
            cloneTarget[key] = deepClone(target[key], map)
        }
        map.set(target, cloneTarget)
    } else {
        cloneTarget = target
    }

    return cloneTarget
}

export function formatNumber(number) {
    if ((!number && number !== 0) || Number.isNaN(number) || number === 'NaN') {
        return null
    }
    const [beforePoint, afterPoint] = ('' + number).split('.')
    const string = beforePoint.split('')
    const ret = []
    for (let i = string.length - 1; i >= 0; i--) {
        ret.unshift(string[i])
        if ((string.length - i) % 3 === 0 && i !== 0) {
            ret.unshift(',')
        }
    }
    return ret.join('') + (afterPoint ? '.' + afterPoint : '')
}

export function wait(number) {
    return new Promise((resolve) => {
        setTimeout(resolve.bind(this), number)
    })
}

export function tableNumberSort(x = '0', y = '0') {
    return Number(('' + x).replace(/,/g, '')) - Number(('' + y).replace(/,/g, ''))
}

export function characterSort(a, b) {
    const aUpper = a?.toUpperCase()
    const bUpper = b?.toUpperCase()
    for (let n = 0; aUpper?.charCodeAt(n) && bUpper?.charCodeAt(n); n++) {
        if (aUpper?.charCodeAt(n) !== bUpper?.charCodeAt(n)) {
            return aUpper?.charCodeAt(n) - bUpper?.charCodeAt(n)
        }
    }
}

export function tableNumberSort4(x = '0', y = '0') {
    let a
    let b = 1
    x.indexOf('-') ? (a = 1) : (a = -1)
    y.indexOf('-') ? (b = 1) : (b = -1)
    return Number(x.replace(/[-+%pt,]/g, '')) * a - Number(y.replace(/[-+%pt,]/g, '')) * b
}
export function unique(arr) {
    const res = new Map()

    return arr.filter((a) => !res.has(a) && res.set(a, 1))
}

export function canvasToClipboard(anchor, ignoreFunction) {
    html2canvas(anchor, {
        ignoreElements: ignoreFunction
    }).then((canvas) => {
        canvas.toBlob(
            (imgBlob) => {
                navigator.clipboard.write([new window.ClipboardItem({ 'image/png': imgBlob })]).then((e) => {
                    showPopAlert({
                        message: i18next.t('home.copyMsg'),
                        status: 'success',
                        timer: 3000
                    })
                })
            },
            'image/png',
            0.9
        )
    })
}

export function mergeFunctionCalls(func) {
    let mergedValue = ''
    let timer = null

    const updateTimer = ({ value }) => {
        mergedValue = value
        clearTimeout(timer)
        timer = setTimeout(() => {
            func({ value: mergedValue })
            reset()
        }, 1000)
    }

    const reset = () => {
        mergedValue = ''
        clearTimeout(timer)
        timer = null
    }

    return (params) => {
        updateTimer(params)
    }
}

export function getQueryString(name, location) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = location.search.substr(1).match(reg)
    if (r != null) {
        return decodeURIComponent(r[2])
    }
    return null
}
export function utcToLocal(date) {
    const fmt = 'YYYY-MM-DD HH:mm:ss'
    return moment.utc(date).local().format(fmt)
}

/**
 * APIで生成したCSVをDLする
 * @param { object } data
 * @param { fileName } data
 */
export const csvDownload = (data, fileName) => {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf])
    const url = window.URL.createObjectURL(new Blob([bom, data], { type: 'text/csv' }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url)
}

export const sortNumber = (rowA, rowB, columnId) => {
    const x = rowA.original[columnId]
    const y = rowB.original[columnId]
    return Number(('' + x).replace(/,/g, '')) - Number(('' + y).replace(/,/g, ''))
}

export const haveUnitSortNumber = (rowA, rowB, columnId) => {
    const x = rowA.original[columnId]
    const y = rowB.original[columnId]
    let a
    let b = 1
    x.indexOf('-') ? (a = 1) : (a = -1)
    y.indexOf('-') ? (b = 1) : (b = -1)
    return Number(x.replace(/[-+%pt,]/g, '')) * a - Number(y.replace(/[-+%pt,]/g, '')) * b
}
